export class PressTracker {
  pressLimit = 0;
  pressPeriod = 0;
  timeLastPress = 0;
  timeSeries = 0;
  pressCount = 0;
  enabled = true;

  constructor() {
    this.setParams(2, 0);
    this.clear();
  }

  clear(): void {
    this.timeLastPress = 0;
    this.timeSeries = 0;
    this.pressCount = 0;
  }

  setParams(pressLimit: number, period: number, enabled?: unknown): void {
    this.pressLimit = pressLimit;
    this.pressPeriod = period;
    this.enabled = enabled === undefined ? true : Boolean(enabled);
  }

  pressedOK(): boolean {
    if (!this.enabled) return true;

    this.pressCount++;
    if (this.pressPeriod === 0) {
      return this.pressCount <= this.pressLimit;
    } else {
      const now = new Date().getTime();
      if (now - this.timeSeries > this.pressPeriod) {
        this.pressCount = 1;
        this.timeSeries = now;
        return true;
      } else {
        return !(now - this.timeSeries < this.pressPeriod && this.pressCount > this.pressLimit);
      }
    }
  }
}
